var generateSts = function (smarttags) {
    var params = {
        smarttags: [],
        sts: new Set(),
    };
    params.smarttags = [];
    params.sts = new Set();
    // iterate over smarttags values
    smarttags.forEach(function (smarttag) {
        smarttag.values.forEach(function (value) {
            // check key duplicates
            var index = params.smarttags.findIndex(function (s) {
                return s.key === smarttag.key;
            });
            var valueIndex;
            if (index > -1) {
                // check if in existed key exist some new values
                valueIndex = params.smarttags[index].values.findIndex(function (v) {
                    return v.key === value.key;
                });
                // if in new value not exist push it
                if (valueIndex === -1) {
                    params.smarttags[index].values.push(value);
                }
            }
            else {
                // key and value doesn't exist
                valueIndex = -1;
                params.smarttags.push({
                    key: smarttag.key,
                    values: [value],
                });
            }
            if (valueIndex === -1) {
                params.sts.add("".concat(smarttag.key, ":").concat(value.key));
            }
        });
    });
    params.sts = Array.from(params.sts);
    return params.sts;
};
export default generateSts;
